module.exports = __webpack_public_path__ + "static/media/Тезисы УОМШ-22 (2 том).61ecc476.pdf";